module.exports = __webpack_public_path__ + "static/img/6.5eda1d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/6.png
// module id = u6eR
// module chunks = 0